
import * as handlebars_family from "../handlebars_family.ts";
import "../layout/layout_modal.mustache";
import "../widget/color-picker.ts";
const TPL = handlebars_family.addTemplate("modal/pickcolor",{"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <div class=\"modal V4\"><div class=\"title\"><icon class=\"modal-close\" data-fw-onclick=\"modalclose\">"
    + container.escapeExpression((lookupProperty(helpers,"iconlib")||(depth0 && lookupProperty(depth0,"iconlib"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"ic_close",{"name":"iconlib","hash":{},"data":data,"loc":{"start":{"line":1,"column":122},"end":{"line":1,"column":144}}}))
    + "</icon> "
    + container.escapeExpression(lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"title") : depth0),{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":152},"end":{"line":1,"column":166}}}))
    + " </div><div class=\"content\"><form><label data-widget=\"widget/color-picker\" data-showhead=\"false\" data-color=\"\" data-no-default=\"true\"></label></form><button data-fw-onclick=\"modalanswer\">"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"actions.ok",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":353},"end":{"line":1,"column":376}}})) != null ? stack1 : "")
    + "</button></div></div> ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = container.invokePartial(lookupProperty(partials,"layout/layout_modal"),depth0,{"name":"layout/layout_modal","fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + " ";
},"usePartial":true,"useData":true});
export default TPL;